import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { actions } from 'forms/rrf';
import { getPipEposSubmission } from '../../../../actions/pip-epos-submissions';
import BackLink from '../../../common/back-link';
import PageTitle from '../../../common/page-title';
import PipEposSubmissionsForm from './pip-epos-submissions-form';
import { isAbmLoggedIn } from '../../../../utils/tokenUtils';

const model = 'deep.admin_pip_epos_submissions';

class PipEposSubmissionsFormPage extends Component {
  constructor(props) {
    super(props);

    this.id = this.props.match.params.id;
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(actions.reset(model));
    dispatch(getPipEposSubmission(this.id));
  }

  componentDidUpdate(prevProps) {
    const { location: { pathname } } = this.props;

    if (prevProps.location.pathname !== pathname) {
      const { dispatch } = this.props;
      const index = 0;

      this.id = pathname.match(/\d+$/)[index];

      dispatch(actions.reset(model));
      dispatch(getPipEposSubmission(this.id));
    }
  }

  render() {
    const { loading } = this.props;
    const abmLoggedIn = isAbmLoggedIn();

    return (
      <div className="container-fluid">
        <Row>
          <Col md={12}>
            <BackLink href={`/${abmLoggedIn ? 'team' : 'admin'}/pip_epos_submissions`} />
          </Col>
        </Row>
        <PageTitle>
          Epos Submission
        </PageTitle>
        {loading ? 'Loading...' : <PipEposSubmissionsForm id={this.id} model={model} />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.pipEposSubmissions.fetching && !state.pipEposSubmissions.fetched
});

export default connect(mapStateToProps)(PipEposSubmissionsFormPage);
